/* eslint-disable radix */
/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
import CustomCategory from 'components/CustomCategory/CustomCategory';
import Button from 'components/common/Button/Button';
import Input from 'components/common/Input/Input';
import Loading from 'components/common/Loading';
import LogViewer from 'components/common/LogViewer';
import { useForm, useModal, useTextInputProps, useToast, useValidation, useNavigation } from 'hooks';
import useUploadSeries from 'hooks/series/useUploadSeries';
import useEditSeries from 'hooks/series/useEditSeries';
import { some } from 'lodash';
import React, { memo, useEffect, useRef, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { createSeriesValidation } from 'utils/constraints';
import Modal from 'components/common/Modal/Modal';
import cn from 'classnames';
import SeriesService from 'services/seriesService';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import CloseIcon from 'components/icons/others/Close';
import LineDoubleIcon from 'components/icons/others/LineDouble';
import { useSelector } from 'react-redux';
import { LOADING } from '@rootstrap/redux-tools';
import { Line } from 'rc-progress';
import parseError from 'utils/parseError';
import Select from 'react-select';
import {
  contentOptions,
  imageSizes,
  moviesImageTypes,
  videoUploadsType
} from 'constants/constants';
import { ValidationErrors } from 'utils/validationErrors';
import { checkImageDimensions, validateVideo, log } from 'utils/helpers';
import { customDropDownStyles } from 'styles/customDropDownStyles';
import ImageCropperModal from 'components/common/ImageCropper/ImageCropperModal';
import { convertTiffToJpeg } from 'components/common/ImageCropper/UrlToImage';
import { convertHeicToJpeg } from 'utils/heicConverter';
import AddEpisodeForm from './AddEpisodeForm';
import { 
  editSeries as editSeriesAction,
  getTrailerUrlForJWPlayer 
} from 'state/actions/seriesActions';

const fields = {
  id: 'id',
  title: 'title',
  description: 'description',
  logo_image: 'logo_image',
  desktop_image: 'desktop_image',
  mobile_image: 'mobile_image',
  categoryIds: 'categoryIds',
  trailer: 'trailer',
  lead_cast: 'lead_cast',
  credits: 'credits',
  content_viewer_category: 'content_viewer_category',
  notify_subscribers: 'notify_subscribers',
  season: 'season'
};

const messages = defineMessages({
  description: { id: 'form.description' },
  descriptionPlaceholder: { id: 'form.seriesDescriptionPlaceholder' },
  title: { id: 'form.title' },
  titlePlaceholder: { id: 'form.seriesTitlePlaceholder' },
  logo: { id: 'form.logo' },
  uploadLogo: { id: 'form.uploadLogo' },
  trailer: { id: 'form.trailer' },
  uploadTrailer: { id: 'form.uploadTrailer' },
  cover: { id: 'form.cover' },
  uploadCover: { id: 'form.uploadCover' },
  coverMobile: { id: 'form.coverMobile' },
  uploadCoverMobile: { id: 'form.uploadCoverMobile' },
  categories: { id: 'form.categories' },
  addBtn: { id: 'form.add' },
  shareTo: { id: 'form.shareTo' },
  episodes: { id: 'label.episodes' },
  addEpisode: { id: 'btn.addEpisode' },
  newEpisode: { id: 'form.newEpisode' },
  video: { id: 'form.video' },
  nameYourEpisodePlaceholder: { id: 'title.nameYourEpisodePlaceholder' },
  descriptionEpisodePlaceholder: { id: 'form.descriptionEpisodePlaceholder' },
  creditStartTime: { id: 'form.creditStartTime' },
  hhmmssPlaceholder: { id: 'form.hhmmssPlaceholder' },
  date: { id: 'form.date' },
  time: { id: 'form.time' },
  releaseDateTimeLabel: { id: 'form.releaseDateTimeLabel' },
  setPriceLabel: { id: 'form.setPriceLabel' },
  nonMembers: { id: 'form.nonMembers' },
  members: { id: 'form.members' },
  chooseVideo: { id: 'form.chooseVideo' },
  earlyReleaseMembers: { id: 'form.earlyReleaseMembers' },
  normalRelease: { id: 'form.normalRelease' }
});
const CreateSeriesForm = ({ id, celId, episodeId }) => {
  const intl = useIntl();
  const { toggle, isShowing } = useModal();
  const validator = useValidation(createSeriesValidation);
  const dispatch = useDispatch();
  const { goTo } = useNavigation();
  const logoRef = useRef(null);
  const trailerRef = useRef(null);
  const desktopCoverRef = useRef(null);
  const mobileCoverRef = useRef(null);
  const [logo, setLogo] = useState(null);
  const { showErrorToast, showToast } = useToast();
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [croppingUrl, setCroppingUrl] = useState();
  const [croppingUrlMimeType, setCroppingUrlMimeType] = useState();
  const [aspectRatio, setAspectRatio] = useState();
  const currentType = useRef();
  const [seriesData, setSeriesData] = useState();
  const [trailer, setTrailer] = useState(null);
  const [selectedContent, setSelectedContent] = useState([]);
  const [desktopCover, setDesktopCover] = useState(null);
  const [mobileCover, setMobileCover] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [subscribedFans, setSubScribedFans] = useState(true);
  const [editEpisodeData, setEditEpisodeData] = useState(null);
  const [trailerLoading, setTrailerLoading] = useState(false);
  const { episode } = useSelector(({ episodes: { episode } }) => ({ episode }));

  const {
    onSubmit: uploadSeries,
    status: createStatus,
    error: createError,
    loading: createLoading,
    uploadProgress: createUploadProgress,
    uploadedVideos: createUploadVideos,
    totalVideos: createTotalVideos,
    uploadingStatus: createUploadingStatus,
    uploadStage: createUploadStage,
    logs: createLogs,
    showLogs: showCreateLogs,
    setShowLogs: setShowCreateLogs,
    seriesId: createdSeriesId,
    currentFileName: createCurrentFileName,
    hasVideosToUpload: createHasVideosToUpload
  } = useUploadSeries();

  const {
    onSubmit: editSeries,
    status: editStatus,
    error: editError,
    loading: editLoading,
    uploadProgress: editUploadProgress,
    uploadedVideos: editUploadVideos,
    totalVideos: editTotalVideos,
    uploadingStatus: edituploadingStatus,
    uploadStage: editUploadStage,
    logs: editLogs,
    showLogs: showEditLogs,
    setShowLogs: setShowEditLogs,
    seriesId: editedSeriesId,
    currentFileName: editCurrentFileName,
    hasVideosToUpload: editHasVideosToUpload
  } = useEditSeries();

  const handleFormSubmit = formData => {
    console.log('Form submit:', {
      selectedCategories,
      type: typeof selectedCategories,
      isArray: Array.isArray(selectedCategories),
      length: Array.isArray(selectedCategories) ? selectedCategories.length : null,
      selectedContent
    });

    // Ensure we have valid categories before submitting
    if (
      !selectedCategories ||
      !Array.isArray(selectedCategories) ||
      selectedCategories.length === 0
    ) {
      showErrorToast('Please select at least one category');
      return;
    }

    // Validate content_viewer_category
    if (!selectedContent || !selectedContent.value) {
      showErrorToast('Please select a content viewer category');
      return;
    }

    // Make sure we're using a valid array of category objects with value property
    const categoryIds = Array.isArray(selectedCategories)
      ? selectedCategories
          .filter(item => item && typeof item === 'object' && 'value' in item)
          .map(item => item.value)
      : [];

    if (categoryIds.length === 0) {
      showErrorToast('Please select at least one valid category');
      return;
    }

    // Prepare the complete form data for both new and edit series
    const completeFormData = {
      ...formData,
      trailer,
      logo_image: logo,
      desktop_image: desktopCover,
      mobile_image: mobileCover,
      episodes,
      categoryIds: selectedCategories, // Keep the full objects for new series
      category_ids: categoryIds, // Use just the IDs for edit series
      content_viewer_category: selectedContent.value,
      notify_subscribers: subscribedFans
    };

    if (!id) {
      // For new series
      uploadSeries(completeFormData);
    } else {
      // For edit series
      editSeries(completeFormData);
    }
  };

  const { values, errors, handleValueChange, handleSubmit, handleBlur, setValues } = useForm(
    {
      onSubmit: handleFormSubmit,
      validator,
      validateOnBlur: true,
      validateOnChange: true,
      initialValues: {
        notify_subscribers: true
      }
    },
    [handleFormSubmit]
  );
  const [episodes, setEpisodes] = useState([]);

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(episodes);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setEpisodes(items);
  }

  function removeCharacter(index) {
    const updatedCharacters = [...episodes];
    updatedCharacters.splice(index, 1);
    setEpisodes(updatedCharacters);
  }
  const inputProps = useTextInputProps(handleValueChange, handleBlur, values);

  const handleLogoUpload = () => {
    logoRef.current.click();
  };

  const handleTrailerUpload = () => {
    trailerRef.current.click();
  };

  const handleDesktopCoverUpload = () => {
    desktopCoverRef.current.click();
  };

  const handleMobileCoverUpload = () => {
    mobileCoverRef.current.click();
  };

  const handleContentChange = e => {
    setSelectedContent(e);
    handleValueChange(fields.content_viewer_category, e.value);
  };

  const isUrl = string => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  const extractFilename = (url, extension) => {
    if (isUrl(url)) {
      const decodedUrl = decodeURIComponent(url);
      const matches = decodedUrl.match(/\/([^\/?#]+)(?=\?|$)/i);
      const fileName = matches && matches[1] ? matches[1] : null;
      return `${fileName}.${extension}`;
    }
    return url?.name;
  };

  const handleLogoChange = async e => {
    const file = e.target.files[0];

    try {
      // Pre-process HEIC files before dimension check
      let processedFile = file;
      const isHeicType =
        /^image\/(heic|heif|heic-sequence|heif-sequence)$/i.test(file.type) ||
        file.name.toLowerCase().endsWith('.heic') ||
        file.name.toLowerCase().endsWith('.heif');

      if (isHeicType) {
        processedFile = await convertHeicToJpeg(file);
      }

      const result = await checkImageDimensions(
        processedFile,
        imageSizes.logo.width,
        imageSizes.logo.height
      );

      if (result.isValid) {
        setCropModalOpen(true);
        setAspectRatio(1 / 1);
        setCroppingUrlMimeType(result.processedFile?.type || processedFile.type);
        setCroppingUrl(result.src);
        currentType.current = moviesImageTypes.Logo;
      } else {
        showErrorToast(result.error);
      }
    } catch (error) {
      console.error('Error processing image:', error);
      showErrorToast('Failed to process image');
    }
  };

  const handleCancel = () => {
    setCropModalOpen(false);
    setCroppingUrl();
    setCroppingUrlMimeType();
    setAspectRatio();
    currentType.current = null;
  };

  const handleCrop = async croppedFile => {
    if (currentType.current === moviesImageTypes.Logo) {
      setLogo(croppedFile);
      handleValueChange(fields.logo_image, croppedFile);
    } else if (currentType.current === moviesImageTypes.coverArtMobile) {
      setMobileCover(croppedFile);
      handleValueChange(fields.mobile_image, croppedFile);
    } else {
      setDesktopCover(croppedFile);
      handleValueChange(fields.desktop_image, croppedFile);
    }
  };

  const resetTrailerInput = () => {
    if (trailerRef.current) {
      trailerRef.current.value = '';
    }
  };

  const handleTrailerChange = async e => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('video/')) {
      // Check for quicktime files and create a modified file object with .mp4 extension
      let processedFile = file;

      if (
        file.type === 'video/quicktime' ||
        file.name.toLowerCase().endsWith('.quicktime') ||
        file.name.toLowerCase().endsWith('.qt')
      ) {
        // Create a new file object with .mp4 extension instead of .quicktime/.qt
        const newName = file.name.replace(/\.(quicktime|qt)$/i, '.mp4');
        processedFile = new File([file], newName, { type: 'video/mp4' });
      }

      const { isValid, isResolutionValid, isResolutionTooHigh, isAspectRatioValid, isFileSizeValid, error } = await validateVideo(
        processedFile,
        videoUploadsType.Movies
      );
      if (error) {
        showErrorToast(ValidationErrors.loadingVideo);
        resetTrailerInput();
      } else if (!isFileSizeValid) {
        showErrorToast(ValidationErrors.fileSizeValidation);
        resetTrailerInput();
      } else if (!isResolutionValid) {
        showErrorToast(ValidationErrors.resolutionValidation);
        resetTrailerInput();
      } else if (isResolutionTooHigh) {
        showErrorToast(ValidationErrors.resolutionTooHighValidation);
        resetTrailerInput();
      } else if (!isAspectRatioValid) {
        showErrorToast(ValidationErrors.aspectRatioValidationForMovies);
        resetTrailerInput();
      } else if (isValid) {
        // Check if file qualifies for multipart upload
        const MULTIPART_UPLOAD_THRESHOLD = 100 * 1024 * 1024; // 100MB threshold
        
        if (processedFile.size >= MULTIPART_UPLOAD_THRESHOLD) {
          try {
            // Show loading indication after a small delay to avoid flickering for fast operations
            setTrailerLoading(true);
            
            // Create multipart upload with mime type
            const { data } = await SeriesService.createMultipartUpload(processedFile.name, processedFile.type);
            const { uploadId, key: mediaId } = data;
            
            // Store multipart upload info in the trailer object
            const multipartVideo = {
              ...processedFile,
              isMultipart: true,
              uploadId,
              mediaId,
              originalFile: processedFile
            };
            
            setTrailer(multipartVideo);
            handleValueChange(fields.trailer, multipartVideo);
            setTrailerLoading(false);
          } catch (error) {
            log('error', 'Failed to initialize multipart upload', {});
            showErrorToast('Failed to initialize multipart upload');
            resetTrailerInput();
            setTrailerLoading(false);
            return;
          }
        } else {
          setTrailer(processedFile);
          handleValueChange(fields.trailer, processedFile);
        }
      }
    } else {
      showErrorToast(ValidationErrors.validFile);
      resetTrailerInput();
    }
  };

  const handleDesktopCoverChange = async e => {
    const file = e.target.files[0];

    try {
      let processedFile = file;
      let imageUrl;

      // Handle HEIC files first
      const isHeicType =
        /^image\/(heic|heif|heic-sequence|heif-sequence)$/i.test(file.type) ||
        file.name.toLowerCase().endsWith('.heic') ||
        file.name.toLowerCase().endsWith('.heif');

      if (isHeicType) {
        processedFile = await convertHeicToJpeg(file);
        imageUrl = URL.createObjectURL(processedFile);
      }
      // Then handle TIFF files
      else if (file.type === 'image/tiff') {
        const jpegDataUrl = await convertTiffToJpeg(file);
        if (!jpegDataUrl) {
          showErrorToast('Failed to convert TIFF image');
          return;
        }
        imageUrl = jpegDataUrl;

        const response = await fetch(jpegDataUrl);
        const blob = await response.blob();
        processedFile = new File([blob], file.name.replace('.tiff', '.jpg'), {
          type: 'image/jpeg'
        });
      } else {
        imageUrl = URL.createObjectURL(file);
      }

      const result = await checkImageDimensions(
        processedFile,
        imageSizes.coverWeb.width,
        imageSizes.coverWeb.height
      );

      if (result.isValid) {
        setCropModalOpen(true);
        setAspectRatio(16 / 9);
        setCroppingUrlMimeType(processedFile.type);
        setCroppingUrl(imageUrl);
        currentType.current = moviesImageTypes.covertArtDesktop;
      } else {
        showErrorToast(result.error);
      }
    } catch (error) {
      console.error('Error processing image:', error);
      showErrorToast('Failed to process image');
    }
  };

  const handleMobileCoverChange = async e => {
    const file = e.target.files[0];

    try {
      let processedFile = file;
      let imageUrl;

      // Handle HEIC files first
      const isHeicType =
        /^image\/(heic|heif|heic-sequence|heif-sequence)$/i.test(file.type) ||
        file.name.toLowerCase().endsWith('.heic') ||
        file.name.toLowerCase().endsWith('.heif');

      if (isHeicType) {
        processedFile = await convertHeicToJpeg(file);
        imageUrl = URL.createObjectURL(processedFile);
      }
      // Then handle TIFF files
      else if (file.type === 'image/tiff') {
        const jpegDataUrl = await convertTiffToJpeg(file);
        if (!jpegDataUrl) {
          showErrorToast('Failed to convert TIFF image');
          return;
        }
        imageUrl = jpegDataUrl;

        const response = await fetch(jpegDataUrl);
        const blob = await response.blob();
        processedFile = new File([blob], file.name.replace('.tiff', '.jpg'), {
          type: 'image/jpeg'
        });
      } else {
        imageUrl = URL.createObjectURL(file);
      }

      const result = await checkImageDimensions(
        processedFile,
        imageSizes.coverMobile.width,
        imageSizes.coverMobile.height
      );

      if (result.isValid) {
        setCropModalOpen(true);
        setAspectRatio(1 / 1);
        setCroppingUrlMimeType(processedFile.type);
        setCroppingUrl(imageUrl);
        currentType.current = moviesImageTypes.coverArtMobile;
      } else {
        showErrorToast(result.error);
      }
    } catch (error) {
      console.error('Error processing image:', error);
      showErrorToast('Failed to process image');
    }
  };

  const handleCategoryChange = selectedOptions => {
    console.log('Category change:', {
      selectedOptions,
      type: typeof selectedOptions,
      isArray: Array.isArray(selectedOptions),
      length: Array.isArray(selectedOptions) ? selectedOptions.length : null
    });

    // Ensure selectedOptions is always an array
    const validOptions = Array.isArray(selectedOptions)
      ? selectedOptions
      : selectedOptions
      ? [selectedOptions]
      : [];

    setSelectedCategories(validOptions);
    handleValueChange(fields.categoryIds, validOptions);
  };

  const getSeriesData = async () => {
    try {
      const { data } = await SeriesService.getOneSeries(id);
      setSeriesData(data.series);
      if (data) {
        setEpisodes(data.series.episodes);
        setLogo(data.series.logoImageUrl);
        setMobileCover(data.series.mobileImageUrl);
        setDesktopCover(data.series.desktopImageUrl);
        setTrailer(data.series.bannerUrl);
      }
    } catch ({ response }) {
      throw parseError(response);
    }
  };

  const isDisabled = () => {
    const isLoading = createStatus === LOADING || editStatus === LOADING;
    const hasErrors = some(errors);
    const areRequiredFieldsMissing = [
      !values[fields.title],
      !values[fields.description],
      !logo,
      !trailer,
      !desktopCover,
      !mobileCover,
      selectedCategories.length === 0,
      !selectedContent || !selectedContent.value
    ].some(Boolean);
    const isSaving = createLoading || editLoading;
    const hasEpisodes = episodes.length === 0;

    return [isLoading, hasErrors, isSaving, hasEpisodes, areRequiredFieldsMissing].some(Boolean);
  };

  const filterEpisodeData = () => {
    const filteredEpisode = episodes.filter(item => item.episodeId === parseInt(episodeId))[0];
    setEditEpisodeData(filteredEpisode);
  };

  useEffect(() => {
    if (editEpisodeData !== null) {
      toggle();
    }
  }, [editEpisodeData]);

  // Episode id is there
  useEffect(() => {
    if (episodeId && episodes.length > 0) {
      filterEpisodeData();
    }
  }, [episodeId, episodes]);

  useEffect(() => {
    if (seriesData && id) {
      const selectedCats = seriesData?.categories.map(item => ({
        value: item.id,
        label: item.name
      }));
      const selectedContent = contentOptions.filter(
        item => item.value === seriesData?.contentViewerCategory
      );
      setSelectedCategories(selectedCats);
      handleValueChange(fields.categoryIds, selectedCats);
      if (seriesData.contentViewerCategory) setSelectedContent(selectedContent[0]);
      setValues({
        ...seriesData,
        [fields.categoryIds]: selectedCats,
        [fields.lead_cast]:
          seriesData.leadCast && seriesData.leadCast !== 'undefined' ? seriesData.leadCast : '',
        [fields.credits]:
          seriesData.credits && seriesData.credits !== 'undefined' ? seriesData.credits : ''
      });
    }
  }, [seriesData]);

  useEffect(() => {
    if (episode) {
      const newData = { ...episode, mime_type: episode.seriesVideo.type, id: episodes.length + 1 };
      if (episodes.length === 0) {
        setEpisodes([newData]);
      } else {
        setEpisodes([...episodes, newData]);
      }
    }
  }, [episode]);

  useEffect(() => {
    if (id) {
      getSeriesData();
      // Initialize the seriesId for existing series
      if (typeof editedSeriesId === 'undefined' || editedSeriesId === null) {
        console.log(`Setting initial series ID from props: ${id}`);
      }
    }
  }, [id]);

  // Log when we get series IDs from the hooks
  useEffect(() => {
    if (createdSeriesId) {
      console.log(`Received createdSeriesId: ${createdSeriesId}`);
    }
  }, [createdSeriesId]);

  useEffect(() => {
    if (editedSeriesId) {
      console.log(`Received editedSeriesId: ${editedSeriesId}`);
    }
  }, [editedSeriesId]);

  const handleRetry = () => {
    console.log('Retry clicked');
    
    try {
      // If we're editing, use either the editedSeriesId from the hook or the id prop
      const currentSeriesId = id ? (editedSeriesId || id) : createdSeriesId;
      console.log(`Current series ID for retry: ${currentSeriesId}`);
      
      // Get the celebrityId from props or a default value
      const celebrityId = celId || '';
      console.log(`Using celebrity ID: ${celebrityId}`);
      
      // Reset error states and form state
      dispatch(editSeriesAction.reset());
      dispatch(getTrailerUrlForJWPlayer.reset());
      
      // If we have a series ID, navigate to edit page with full page refresh
      if (currentSeriesId) {
        console.log(`Refreshing page and redirecting to edit originals page for ID: ${currentSeriesId}`);
        
        // Show toast message before redirect
        showToast('Redirecting to edit page. Please wait...');
        
        // Add a short delay to ensure the toast is visible
        setTimeout(() => {
          window.location.href = `/edit-originals/${currentSeriesId}/${celebrityId}`;
        }, 1500);
        return;
      }
      
      // If we don't have a series ID, show toast and reload
      showToast('No series ID available. Refreshing the page...');
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error('Error in retry function:', error);
      // In case of error, show toast and force a page reload as fallback
      showErrorToast('Error occurred. Refreshing the page...');
      log('error', 'Error occurred. Refreshing the page', error);

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  };

  return (
    <div className="series-form">
      <div className="series-form-fields">
        <Input
          name="title"
          placeholder={intl.formatMessage(messages.titlePlaceholder)}
          label={intl.formatMessage(messages.title)}
          errors={errors[fields.title]}
          {...inputProps(fields.title)}
        />
        <Input
          name="description"
          placeholder={intl.formatMessage(messages.descriptionPlaceholder)}
          label={intl.formatMessage(messages.description)}
          errors={errors[fields.description]}
          {...inputProps(fields.description)}
        />
        <Input
          name="seriesLeadCast"
          placeholder="Lead cast name"
          label="Lead Cast (optional)"
          errors={errors[fields.lead_cast]}
          {...inputProps(fields.lead_cast)}
        />
        <Input
          name="seriesCredits"
          placeholder="Credits for season"
          label="Credits (optional)"
          errors={errors[fields.credits]}
          {...inputProps(fields.credits)}
        />
        <CustomCategory value={selectedCategories} handleCategoryChange={handleCategoryChange} />
        <div style={{ width: '100%' }} className={cn('custom-content')}>
          <span className="custom-content-label">Content Viewers</span>
          <div className="single-select">
            <Select
              value={selectedContent}
              options={contentOptions}
              onChange={handleContentChange}
              styles={customDropDownStyles}
              isSearchable={false}
            />
          </div>
        </div>  
        <input
          type="file"
          ref={logoRef}
          style={{ display: 'none' }}
          accept="image/*,.heic,.heif"
          name="logo_image"
          onChange={handleLogoChange}
        />
        <input
          type="file"
          ref={trailerRef}
          style={{ display: 'none' }}
          accept=".mp4,.mov"
          onChange={handleTrailerChange}
          name="trailer"
        />
        <input
          type="file"
          ref={desktopCoverRef}
          style={{ display: 'none' }}
          accept="image/*,.heic,.heif"
          name="desktop_image"
          onChange={handleDesktopCoverChange}
        />
        <input
          type="file"
          ref={mobileCoverRef}
          style={{ display: 'none' }}
          accept="image/*,.heic,.heif"
          onChange={handleMobileCoverChange}
          name="mobile_image"
        />
        <div className="upload-div">
          <span className={logo?.name ? 'white-custom-label' : 'custom-label'}>
            {intl.formatMessage(messages.logo)}
          </span>
          {logo ? (
            <div className="white-label">
              <span className="white-name">{extractFilename(logo, 'png')}</span>
              <span
                className="white-name"
                style={{ cursor: 'pointer' }}
                onClick={() => setLogo(null)}
              >
                x
              </span>
            </div>
          ) : (
            <div className="button-margin">
              <Button
                labelId={intl.formatMessage(messages.uploadLogo)}
                type="secondary"
                onClick={handleLogoUpload}
                className="trailer-button"
              />
              <span className="label-margin">Recommended dimension: 500px X 500px (1:1)</span>
            </div>
          )}
        </div>
        <div className="upload-div">
          <span className={trailer?.name ? 'white-custom-label' : 'custom-label'}>
            {intl.formatMessage(messages.trailer)}
          </span>
          {trailer ? (
            <div className="white-label">
              <span className="white-name">
                {typeof trailer === 'string'
                  ? extractFilename(trailer, 'mp4')
                  : trailer.isMultipart
                  ? `${trailer.originalFile.name} (Multipart Upload)`
                  : trailer.name}
              </span>
              <span
                className="white-name"
                style={{ cursor: 'pointer' }}
                onClick={() => setTrailer(null)}
              >
                x
              </span>
            </div>
          ) : (
            <div className="button-margin">
              {trailerLoading ? (
                <div style={{ color: 'white', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Loading type="ball-clip-rotate" />
                    <span style={{ marginLeft: '10px' }}>Initializing multipart upload...</span>
                  </div>
                  <button
                    onClick={() => {
                      setTrailerLoading(false);
                      resetTrailerInput();
                    }}
                    style={{ 
                      marginTop: '10px', 
                      padding: '5px 15px', 
                      backgroundColor: '#333',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <>
                  <Button
                    labelId={intl.formatMessage(messages.uploadTrailer)}
                    type="secondary"
                    onClick={handleTrailerUpload}
                    className="trailer-button"
                  />
                  <span className="label-margin">Recommended dimension: 1280px X 720px (16:9)</span>
                </>
              )}
            </div>
          )}
        </div>
        <div className="upload-div">
          <span className={desktopCover?.name ? 'white-custom-label' : 'custom-label'}>
            {intl.formatMessage(messages.cover)}
          </span>
          {desktopCover ? (
            <div className="white-label">
              <span className="white-name">{extractFilename(desktopCover, 'png')}</span>
              <span
                className="white-name"
                style={{ cursor: 'pointer' }}
                onClick={() => setDesktopCover(null)}
              >
                x
              </span>
            </div>
          ) : (
            <div className="button-margin">
              <Button
                labelId={intl.formatMessage(messages.uploadCover)}
                type="secondary"
                onClick={handleDesktopCoverUpload}
                className="trailer-button"
              />
              <span className="label-margin">Recommended dimension: 1280px X 720px (16:9)</span>
            </div>
          )}
        </div>
        <div className="upload-div">
          <span className={mobileCover?.name ? 'white-custom-label' : 'custom-label'}>
            {intl.formatMessage(messages.coverMobile)}
          </span>
          {mobileCover ? (
            <div className="white-label">
              <span className="white-name">{extractFilename(mobileCover, 'png')}</span>
              <span
                className="white-name"
                style={{ cursor: 'pointer' }}
                onClick={() => setMobileCover(null)}
              >
                x
              </span>
            </div>
          ) : (
            <div className="button-margin">
              <Button
                labelId={intl.formatMessage(messages.uploadCoverMobile)}
                type="secondary"
                onClick={handleMobileCoverUpload}
                className="trailer-button"
              />
              <span className="label-margin">Recommended dimension: 720px X 720px (1:1)</span>
            </div>
          )}
        </div>
        <div className={cn('notify-box')}>
          <input
            type="checkbox"
            checked={subscribedFans}
            onChange={() => {
              setSubScribedFans(!subscribedFans);
              handleValueChange(fields.notify_subscribers, !subscribedFans);
            }}
          />
          Notify all paid fans
        </div>
        <div className="dnd-series-list">
          <h2>Episodes ({episodes.length})</h2>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="episodes">
              {provided => (
                <ul className="characters" {...provided.droppableProps} ref={provided.innerRef}>
                  {episodes.map(({ id, title }, index) => {
                    return (
                      <Draggable key={id} draggableId={id.toString()} index={index}>
                        {provided => (
                          <li
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <span>{index + 1}</span>
                            <div>
                              <p>
                                <LineDoubleIcon />
                                <span>{title}</span>
                              </p>
                              <button onClick={() => removeCharacter(index)}>
                                <CloseIcon color="#969696" />
                              </button>
                            </div>
                          </li>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
          {/* Show progress bar when videos are being uploaded and we're not in completed stage */}
          {((createHasVideosToUpload && (createUploadProgress > 0 || createUploadStage)) || 
             (editHasVideosToUpload && (editUploadProgress > 0 || editUploadStage))) && 
             (createUploadStage !== 'completed' && editUploadStage !== 'completed') && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '15px',
                borderRadius: '8px',
                width: '100%'
              }}
            >
              <div 
                style={{ 
                  textAlign: 'center', 
                  marginTop: '5px', 
                  color: 'white',
                  width: '100%' 
                }}
              >
                {(createUploadStage === 'validating' || editUploadStage === 'validating') && (
                  <div className="upload-status">
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Validating Files</div>
                    <div style={{ fontSize: '0.9em' }}>Checking file validations before upload...</div>
                  </div>
                )}
                {(createUploadStage === 'validated' || editUploadStage === 'validated') && (
                  <div className="upload-status">
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Validation Passed</div>
                    <div style={{ fontSize: '0.9em' }}>Preparing files for upload...</div>
                  </div>
                )}
                {(createUploadStage === 'uploading' || editUploadStage === 'uploading') && (
                  <div className="upload-status">
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                      Uploading Video {(createUploadVideos || editUploadVideos) + 1} of {createTotalVideos || editTotalVideos}
                    </div>
                    <div style={{ 
                      fontSize: '0.9em', 
                      marginTop: '5px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '100%'
                    }}>
                      {createCurrentFileName || editCurrentFileName || 'Current file'}
                    </div>
                  </div>
                )}
                {(createUploadStage === 'processing' || editUploadStage === 'processing') && (
                  <div className="upload-status">
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Processing</div>
                    <div style={{ fontSize: '0.9em' }}>
                      Processing video {(createUploadVideos || editUploadVideos) + 1} of {createTotalVideos || editTotalVideos}...
                    </div>
                  </div>
                )}
                {!createUploadStage && !editUploadStage && (createLoading || editLoading) && (createHasVideosToUpload || editHasVideosToUpload) && (
                  <div className="upload-status">
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Preparing Upload</div>
                    <div style={{ fontSize: '0.9em' }}>Getting ready to upload your files...</div>
                  </div>
                )}
              </div>
              <div style={{ width: '100%', padding: '10px 0' }}>
                <Line
                  percent={createUploadProgress || editUploadProgress || 0}
                  strokeWidth={2}
                  strokeColor="#2400FC"
                  trailColor="#444"
                />
              </div>
              <div
                style={{
                  textAlign: 'center',
                  marginTop: '5px',
                  marginBottom: '5px',
                  color: 'white',
                  fontSize: '0.9em'
                }}
              >
                {createUploadProgress || editUploadProgress || 0}% Complete
              </div>
            </div>
          )}
          {/* Show the "Upload Completed" message separately, without progress bar */}
          {((createUploadStage === 'completed' || editUploadStage === 'completed')) && (
            <div
              style={{
                marginBottom: '15px',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '15px',
                borderRadius: '8px',
                width: '100%'
              }}
            >
              <div className="upload-status">
                <div style={{ fontWeight: 'bold', marginBottom: '5px', color: '#4caf50' }}>Upload Completed</div>
                <div style={{ fontSize: '0.9em' }}>All files uploaded successfully!</div>
              </div>
            </div>
          )}
          {/* Always show the normal loader during loading states */}
          {((createStatus || editStatus) === LOADING || (createLoading || editLoading)) && (
            <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'center' }}>
              <Loading type="ball-clip-rotate" />
            </div>
          )}
          <div className="flex-buttons">
            <Button labelId="btn.addEpisode" className="submit-button" onClick={toggle} white />
            <Button
              labelId={id ? 'Save Changes' : 'form.narrative.submit'}
              className="share-button"
              onClick={handleSubmit}
              disabled={isDisabled()}
            ></Button>
          </div>
        </div>
        <div className="creator-form-error p1" style={{ color: 'red', margin: '0 1.4rem 2.6rem' }}>
          {(createError || editError) && (
            <>
              <div>{createError || editError}</div>
              <button 
                onClick={handleRetry}
                className="retry-button"
                style={{
                  marginTop: '10px',
                  padding: '8px 16px',
                  backgroundColor: '#2400FC',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Retry
              </button>
            </>
          )}
        </div>

        {/* Error logs are auto-displayed */}
        {!id && (
          <div className="debug-log-section" style={{ margin: '0 1.4rem 2.6rem' }}>
            <LogViewer
              logs={createLogs}
              showLogs={showCreateLogs}
              setShowLogs={setShowCreateLogs}
              title="Upload Process Errors"
            />
          </div>
        )}
        {id && (
          <div className="debug-log-section" style={{ margin: '0 1.4rem 2.6rem' }}>
            <LogViewer
              logs={editLogs}
              showLogs={showEditLogs}
              setShowLogs={setShowEditLogs}
              title="Edit Process Errors"
            />
          </div>
        )}
      </div>
      <Modal
        hide={toggle}
        isShowing={isShowing}
        preventClose={!!editEpisodeData}
        className="series-form-modal"
      >
        <AddEpisodeForm handleClose={toggle} editEpisodeData={editEpisodeData} seriesId={id} />
      </Modal>
      {cropModalOpen && (
        <ImageCropperModal
          visible={cropModalOpen}
          imageUrl={croppingUrl}
          onCancel={handleCancel}
          onCrop={handleCrop}
          aspectRatio={aspectRatio}
          mimeType={croppingUrlMimeType === 'image/png' ? croppingUrlMimeType : 'image/jpeg'}
        />
      )}
    </div>
  );
};

export default memo(CreateSeriesForm);
